@if (label()) {
  <label [for]="id()" class="block text-sm leading-6 text-gray-900 font-bold">{{ label() }}</label>
}
<input
  #input
  [id]="id()"
  [name]="name() || id()"
  [placeholder]="placeholder() || '' | i18n"
  (focus)="showOverlay()"
  (blur)="hideOverlay()"
  [(ngModel)]="filter"
  (keydown)="onKeyDown($event)"
  class="mt-2 block w-full border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primary-600 sm:text-sm sm:leading-6"
/>
